module.exports = __webpack_public_path__ + "media/Emergency-fr.b0e5211c.wav";